export default class OpenTopicsMenu {
  constructor(context) {
    this.context = context;
  }

  run(params) {
    this.context.analytics.track('Topics Menu Opened', params);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/conversation/topics_menu/open_topics_menu.js